import React from 'react';
import {
  FaThLarge,
  FaUsers,
  FaBuilding,
  FaExchangeAlt,
  FaCog,
  FaDollarSign,
  FaUser,
  FaChevronRight,
  FaChevronLeft,
  FaSignOutAlt
} from 'react-icons/fa';
import { CloseOutlined, DollarOutlined, LogoutOutlined, SettingOutlined, UserOutlined } from '@ant-design/icons';
import { Link, NavLink, useNavigate } from 'react-router-dom';
import '../layout-admin/css/sidebar.css'

import '../layout-admin/css/index.css';
import category from '../assets/images/category.png'
import arrowsdoublesenw from '../assets/images/arrows-double-se-nw.png'
import buildingstore from '../assets/images/building-store.png'
import users from '../assets/images/users.png'
import { Button } from 'antd';

const SidebarAdmin = ({ isSidebarCollapsed, setIsSidebarCollapsed, setIsSidebarOpen }) => {
  const navigate = useNavigate();
  const currentUser = JSON.parse(sessionStorage.getItem('authAdmin'));

  // Rôles
  const isAdmin =
    currentUser?.roles?.includes('ADMIN') ||
    currentUser?.user?.newAdmin === true;

  // Si pas admin, on ne rend rien
 /*  if (!isAdmin) return null; */

  return (
    <aside className={`sidebar-admine ${isSidebarCollapsed ? 'collapsed' : ''}`}>
      {/* Header du sidebar */}

      {/* Corps du menu */}
      <div className="sidebar-menu">
        <nav className="">
          <NavLink
            to="/dashboard-admin"
            className={({ isActive }) =>
             `menu-admine sidebar-item-admin ${isActive ? 'active' : ''}`
            }
            >
            <img src={category} alt="Bientôt" style={{ width: 24, height: 24 }} />
            {!isSidebarCollapsed && (
            <span className="menu-admine">Tableau de bord</span>
            )}
        </NavLink>
          <NavLink
            to="/marchand"
            className={({ isActive }) =>
              `menu-admine sidebar-item-admin ${isActive ? 'active' : ''}`
            }
          >
            <img src={users} alt="Bientôt" style={{ width: 24, height: 24 }} />
            {!isSidebarCollapsed && (
              <span className="menu-admine">Marchands</span>
            )}
          </NavLink>

          <NavLink
            to="/business-management"
            className={({ isActive }) =>
              `menu-admine sidebar-item-admin ${isActive ? 'active' : ''}`
            }
          >
            <img src={buildingstore} alt="Bientôt" style={{ width: 24, height: 24 }} />
            {!isSidebarCollapsed && (
              <span className="menu-admine ">Business</span>
            )}
          </NavLink>

          <NavLink
            to="/transaction-admin"
            className={({ isActive }) =>
              `menu-admine sidebar-item-admin  ${isActive ? 'active' : ''}`
            }
          >
            <img src={arrowsdoublesenw} alt="Bientôt" style={{ width: 24, height: 24 }} />
            {!isSidebarCollapsed && (
              <span className="menu-admine">Transactions</span>
            )}
          </NavLink>

                     

          {/* Sous-section : Paramètres */}
          {!isSidebarCollapsed && (
            <div className="menu-admine"style={{gap:'8px'}}>
               <SettingOutlined/> <span>Paramètres</span>
            </div>
          )}
          <NavLink
            to="/parametres/commissions"
            className={({ isActive }) =>
                `menu-admine sidebar-item-admin ${isActive ? 'active' : ''}`
            }
            >
            <DollarOutlined />
            {!isSidebarCollapsed && (
                <span className="menu-admine">Commissions</span>
            )}
            </NavLink>

          <NavLink
            to="/parametres/utilisateurs"
            className={({ isActive }) =>
                `menu-admine sidebar-item-admin ${isActive ? 'active' : ''}`
            }
            >
            <UserOutlined />
            {!isSidebarCollapsed && (
                <span className="menu-admine">Utilisateurs</span>
            )}
            </NavLink>
        </nav>
      </div>

      {/* Pied du sidebar */}
        <div className="logout-container ">
        <Link to="/logout">
        <Button className='deconnect-button-admin menue-admin ' icon={<LogoutOutlined />}>
          <span>Se déconnecter</span>
        </Button>
        </Link>
      </div>
    </aside>
  );
};

export default SidebarAdmin;